import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';

@Component({
	selector: 'app-toast-container',
	imports: [ToastModule],
	template: ` <p-toast position="top-right" styleClass="toast-container"></p-toast> `,
	styleUrl: './toast-container.component.scss'
})
export class ToastContainerComponent {}
